<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">

                    
                    <div class="col-md-3 searching">
                        <span class="h_page">Kepegawaian</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <select class="form-control" v-model="tab">
                                <option>Divisi</option>
                                <option>Jabatan</option>
                                <option>Pegawai</option>
                                <option>Posisi Pegawai</option>
                            </select>
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>

                <div v-if ="tab == 'Divisi'">
                    <bhumie_kepegawaian_divisi></bhumie_kepegawaian_divisi>
                </div>

                <div v-if ="tab == 'Jabatan'">
                    <bhumie_kepegawaian_jabatan></bhumie_kepegawaian_jabatan>
                </div>

                <div v-if ="tab == 'Pegawai'">
                    <bhumie_kepegawaian_pegawai></bhumie_kepegawaian_pegawai>
                </div>

                <div v-if ="tab == 'Posisi Pegawai'">
                    <bhumie_kepegawaian_posisi_pegawai></bhumie_kepegawaian_posisi_pegawai>
                </div>










        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
        tab : "Divisi",
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
      pilih_tab : function(){

      }

  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
